import React, { type ReactElement } from 'react';

import SearchFilter from './search-filter';
import SearchForm from './search-form';
import SearchResults from './search-results';
import Share from './share';

import { useDfContext } from '../context/df-context';
import { getConfig, getTranslation } from '../utils/config';
import { LoadingRing } from './loading-ring';
import { PAGE_VARIANT, TRANSLATION_SEPARATOR } from '../constants';

export default function DfSearch({
  variant = PAGE_VARIANT.SEARCH,
}: {
  variant: string;
}): ReactElement {
  const {
    state: { term, totalDownloads, isLoading },
  } = useDfContext();

  const [beforeCounter, afterCounter] = getTranslation(
    totalDownloads === 1 ? 'result_counter' : 'results_counter',
    TRANSLATION_SEPARATOR,
  ).split(TRANSLATION_SEPARATOR);

  return (
    <section className="df-search-modul">
      {variant !== PAGE_VARIANT.RESULT && (
        <>
          <h2 className="df-sub-headline" aria-hidden="true">
            {getTranslation('search_subtitle')}
          </h2>
        </>
      )}
      {variant === PAGE_VARIANT.RESULT && (
        <>
          {term && (
            <h2 className="df-sub-headline">
              {isLoading ? <LoadingRing /> : <strong>{totalDownloads}</strong>}&nbsp;
              <span>
                {getTranslation(
                  totalDownloads === 1 ? 'search_result_title' : 'search_results_title',
                )}
                &nbsp;
              </span>
              <strong>{term}</strong>
            </h2>
          )}
          <div className="df-share-page">
            <Share type="overview" />
          </div>
        </>
      )}
      <SearchForm variant={variant} />
      {variant !== PAGE_VARIANT.RESULT && <SearchResults />}
      <div className="df-search-modul__button-wrapper">
        <SearchFilter variant={variant} label={getTranslation('filter_title')} />
        <a href={getConfig('resultsPage')} className="df-btn df-btn__total-downloads">
          {beforeCounter}
          {isLoading ? <LoadingRing /> : null}
          {!isLoading && (!totalDownloads ? ' ' : totalDownloads + ' ')}
          {afterCounter}
          <span className="df-btn__icon-right df-icon-arrow_long_right_white" />
        </a>
      </div>
    </section>
  );
}
